import React from 'react';
import {
  PieChart, Pie, Cell,
  LineChart, Line, XAxis, YAxis, Tooltip,
  BarChart, Bar, ResponsiveContainer
} from 'recharts';

const TableauBordFonctionnel = () => {
  const ticketsAQualifier = [
    { id: 1, titre: 'Erreur validation', statut: 'En attente client' },
    { id: 2, titre: 'Nouveau champ demande', statut: 'À qualifier' },
    { id: 3, titre: 'Comportement incohérent', statut: 'En attente client' }
  ];

  const dataRecurrence = [
    { name: 'Récurrents', value: 40 },
    { name: 'Uniques', value: 60 }
  ];
  const colors = ['#e11d48', '#3b82f6'];

  const dataTestFonctionnel = [
    { date: '2025-06-01', count: 2 },
    { date: '2025-06-02', count: 3 },
    { date: '2025-06-03', count: 4 },
    { date: '2025-06-04', count: 2 }
  ];

  const dataEchangesClient = [
    { client: 'Client A', count: 5 },
    { client: 'Client B', count: 2 },
    { client: 'Client C', count: 4 }
  ];

  const nbDemandesEvolution = 7;

  return (
    <div className="p-8 bg-gray-100 min-h-screen">
      <h1 className="text-3xl font-bold text-gray-800 mb-10">🧾 Tableau de bord Fonctionnel</h1>

      {/* Grille principale */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">

        {/* Tickets à qualifier */}
        <div className="bg-white rounded-2xl shadow-md p-6 col-span-1">
          <h2 className="text-xl font-semibold text-indigo-600 mb-4">🟡 Tickets à qualifier / en attente client</h2>
          <table className="w-full text-sm text-left border">
            <thead className="bg-indigo-50 text-gray-700">
              <tr>
                <th className="p-2 border">Titre</th>
                <th className="p-2 border">Statut</th>
              </tr>
            </thead>
            <tbody>
              {ticketsAQualifier.map(t => (
                <tr key={t.id} className="bg-white hover:bg-indigo-50 transition">
                  <td className="p-2 border">{t.titre}</td>
                  <td className="p-2 border">{t.statut}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Taux de récurrence */}
        <div className="bg-white rounded-2xl shadow-md p-6 flex flex-col items-center">
          <h2 className="text-xl font-semibold text-rose-600 mb-4">🔁 Taux de tickets récurrents</h2>
          <ResponsiveContainer width="100%" height={250}>
            <PieChart>
              <Pie data={dataRecurrence} dataKey="value" nameKey="name" outerRadius={90} label>
                {dataRecurrence.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={colors[index]} />
                ))}
              </Pie>
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>

        {/* Tickets en phase de test fonctionnel */}
        <div className="bg-white rounded-2xl shadow-md p-6 col-span-1">
          <h2 className="text-xl font-semibold text-green-700 mb-4">🧪 Évolution des tests fonctionnels</h2>
          <ResponsiveContainer width="100%" height={250}>
            <LineChart data={dataTestFonctionnel}>
              <XAxis dataKey="date" />
              <YAxis />
              <Tooltip />
              <Line type="monotone" dataKey="count" stroke="#10b981" strokeWidth={3} />
            </LineChart>
          </ResponsiveContainer>
        </div>

        {/* Tickets avec échanges client */}
        <div className="bg-white rounded-2xl shadow-md p-6 col-span-1">
          <h2 className="text-xl font-semibold text-blue-600 mb-4">💬 Nombre de tickets avec échanges client</h2>
          <ResponsiveContainer width="100%" height={250}>
            <BarChart data={dataEchangesClient}>
              <XAxis dataKey="client" />
              <YAxis />
              <Tooltip />
              <Bar dataKey="count" fill="#3b82f6" radius={[5, 5, 0, 0]} />
            </BarChart>
          </ResponsiveContainer>
        </div>
      </div>

      {/* En bas : nombre total demandes d’évolution */}
      <div className="mt-10 bg-white rounded-2xl shadow-md p-6 text-center w-full max-w-xl mx-auto">
        <h2 className="text-xl font-semibold text-amber-600 mb-2">🆕 Tickets liés à des demandes d’évolution</h2>
        <div className="text-5xl font-bold text-amber-700">{nbDemandesEvolution}</div>
      </div>
    </div>
  );
};

export default TableauBordFonctionnel;
